var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFruitNinja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 16,
    fill: "#FDDB44",
    stroke: "#184985",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#184985",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 26c-2.6-3.4-8-4.8-12.4-1.4C14.2 28.6 13 37.2 16.4 44.2 19.2 50 25.6 53.2 32 50.6 38.4 53.2 44.8 50 47.6 44.2 51 37.2 49.8 28.6 44.4 24.6 40 21.2 34.6 22.6 32 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26V15.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 18.5c3.4-5.8 11-7.6 14.2-4.8-1.3 5-6.8 7.6-14.2 7.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruitNinja);
export default __webpack_public_path__ + "static/media/fruit-ninja.67538a3dba9c158176356278cd8229fa.svg";
export { ForwardRef as ReactComponent };